import { AppState } from '@/types';

import { UserReducerState as State } from './types';

export const selectUserInfo = (state: AppState): State['userInfo'] => {
  return state.user.userInfo;
};

// Used in global saga that need to be refactored
export const selectIsUserAuthorizedToSell = (state: AppState): boolean => {
  return Boolean(selectUserInfo(state)?.companyInfo.isAuthorizedToSell);
};
